import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/servicePagesSections/priceStyles.js"

const useStyles = makeStyles(styles);

export default function HennaSection() {
    const classes = useStyles();  
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>Prices</h2>
      <div className={classes.description}>
      <GridContainer>
          <GridItem xs={12}>
                <h3 className={classes.product}>Henna tattoos start at $10 and don't worry, we will discuss pricing before applying any henna tattoos.</h3>
            </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
